function showQuestionDetail(questionId) {
    const questionItem = $(`.question-item[data-question-id="${questionId}"]`);
    const locale = $('#locale').val();

    const questionText = questionItem.data('question');
    const answerText = questionItem.data('answer');

    if(locale === 'vi') {
        $('#popupQuestion').text(`Câu hỏi: ${questionText}`);
    }else{
        $('#popupQuestion').text(`Question: ${questionText}`);
    }
    $('#popupAnswer').text(answerText);

    $('#questionPopup').css('display', 'flex');
    setTimeout(() => $('#questionPopup').addClass('active'), 10);

    $('#faqPopupAnswer').addClass('show');
    $('.faq-question').removeClass('collapsed');
}

function closePopup() {
    $('#questionPopup').removeClass('active');
    setTimeout(() => $('#questionPopup').css('display', 'none'), 300);
}

$(document).click(function (event) {
    $('.faq-question').removeClass('collapsed');
    if ($(event.target).is('#questionPopup')) {
        closePopup();
    }
});
